import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core/WorksheetEquipment';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createPortionLabelSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';

// Section for determining masses of the coarse/fine portions of a separation
// where separation portion is dry
let SeparationDryMassesSection: React.FC<IWorksheetComponent & { heading: string }> = ({
  createWorksheetSelector,
  namePrefix,
  heading,
}) => {
  let coarsePortionLabel = useSelector(
    createPortionLabelSelector(createWorksheetSelector!, `${namePrefix}.CoarsePortion`)
  );
  let finePortionLabel = useSelector(createPortionLabelSelector(createWorksheetSelector!, `${namePrefix}.FinePortion`));

  // For first separation we record coarse and fine mass.
  if (namePrefix!.endsWith('.WholePortion.Separation'))
    return (
      <ListFieldSection heading={heading}>
        {/* Shared Fields - use coarse portion as primary field and copy to fine portion */}
        <WorksheetBalanceFieldSet
          label="Balance"
          name="CoarsePortion.Masses.MassMeasurement.Equipment.Balance"
          copyTo={[
            'CoarsePortion.Masses.MassMeasurement.Equipment.DryMassBalance',
            'FinePortion.Masses.MassMeasurement.Equipment.Balance',
            'FinePortion.Masses.MassMeasurement.Equipment.DryMassBalance',
          ]}
        />
        <Field
          input={<NumericInput />}
          name="CoarsePortion.Masses.MassMeasurement.TareMass"
          label="Tare Mass"
          copyTo={['FinePortion.Masses.MassMeasurement.TareMass']}
        />
        <NamePrefixModifier appendNamePrefix={`CoarsePortion.Masses.MassMeasurement`}>
          <Field input={<NumericInput />} name="TareAndDryMass" label={`Tare and ${coarsePortionLabel} Dry Mass`} />
          <Field input={<TextOutput />} name="DryMass" label={`${coarsePortionLabel} Dry Mass`} />
        </NamePrefixModifier>
        <NamePrefixModifier appendNamePrefix={`FinePortion.Masses.MassMeasurement`}>
          <Field input={<NumericInput />} name="TareAndDryMass" label={`Tare and ${finePortionLabel} Dry Mass`} />
          <Field input={<TextOutput />} name="DryMass" label={`${finePortionLabel} Dry Mass`} />
        </NamePrefixModifier>
      </ListFieldSection>
    );

  // For subsequent separations we record coarse mass and calculate fine mass.
  return (
    <ListFieldSection heading={heading}>
      <NamePrefixModifier appendNamePrefix={'CoarsePortion.Masses.MassMeasurement'}>
        <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
        <Field input={<NumericInput />} name="TareMass" label="Tare Mass" />
        <Field input={<NumericInput />} name="TareAndDryMass" label={`Tare and ${coarsePortionLabel} Dry Mass`} />
        <Field input={<TextOutput />} name="DryMass" label={`${coarsePortionLabel} Dry Mass`} />
      </NamePrefixModifier>
      <NamePrefixModifier appendNamePrefix={`FinePortion.Masses`}>
        <Field input={<TextOutput />} name="DryMass" label={`${finePortionLabel} Dry Mass`} />
      </NamePrefixModifier>
    </ListFieldSection>
  );
};

SeparationDryMassesSection = withInjectedProps(SeparationDryMassesSection);

export { SeparationDryMassesSection };
export default SeparationDryMassesSection;
